<script setup lang="ts">
import { t } from '@shared/i18n';
import sharedStores from '@shared/shared-stores';
import { watch } from 'vue';

const props = defineProps<{
  show: boolean;
  chapterNumber: string;
}>();

const { addConfetti } = sharedStores.animate.funcs;
const baseUrl = (import.meta as any).env.VITE_JAALUU_API_URL;
const success = new Audio(`${baseUrl}/v1/file/sounds/success_long.mp3`);

watch(
  () => props.show,
  (val) => {
    if (val) {
      addConfetti();
      success.play().catch((err) => console.error('Error playing success sound:', err));
    }
  }
);
</script>

<template>
  <v-snackbar :model-value="show" multi-line color="white" timeout="-1">
    <div class="title d-flex justify-center">{{ t('general.well_done') }}</div>
    <div class="d-flex flex-column align-center">
      <div class="title-md mt-2">{{ t('course.chapter_completed') }}</div>
      <div class="mt-6 jump-animation" v-if="show">
        <v-chip variant="tonal" color="green" size="large">
          <v-icon size="20" color="green" icon="mdi-book-check" class="mr-2" />
          <span>{{ t('grammar.chapter') }} {{ chapterNumber }}</span>
          <v-icon size="20" color="green" icon="mdi-check-bold" class="ml-2" />
        </v-chip>
      </div>
    </div>
  </v-snackbar>
</template>

<style scoped lang="scss">
.jump-animation {
  animation: jump 0.6s ease-in-out infinite;
}

@keyframes jump {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
}
</style>
